import React, { ChangeEvent, FocusEventHandler, useEffect, useRef, useState } from 'react';
import { CustomTextField, VerificationCodeInputContainer } from './VerificationCodeInput.styles';


export interface CustomVerificationCodeInputProps {
    inputLength: number;
    getConcatenatedValues: Function;
    hasError: Function;
    errorFromOutside?: boolean;
}

export const VerificationCodeInput = ({
    inputLength,
    getConcatenatedValues,
    hasError,
    errorFromOutside = false,
    ...rest
}: CustomVerificationCodeInputProps) => {

    const inputRefs = Array.from({ length: inputLength }, () => useRef<HTMLInputElement>());
    const [values, setValues] = useState(Array(inputLength).fill(''));
    const [errors, setErrors] = useState(Array(inputLength).fill(false));

    const handleInputChange = (index: number) => (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        inputRefs[index].current!.value = value;

        if (value.length === 1 && index < inputRefs.length - 1) {
            inputRefs[index + 1].current!.focus();
        }

        const newValues = [...values];
        newValues[index] = value;
        setValues(newValues);

        const newErrors = [...errors];
        newErrors[index] = false;
        setErrors(newErrors);

        const concatenatedValues = newValues.join('');
        getConcatenatedValues(concatenatedValues);
        hasError(newErrors.some(error => error === true))
    };

    const handleBlur = (index: number) => (event: any) => {
        const newErrors = [...errors];

        if (values[index].trim() === '') {
            newErrors[index] = true;
        } else {
            newErrors[index] = false;
        }

        setErrors(newErrors);
        hasError(newErrors.some(error => error === true))
    };

    return (
        <VerificationCodeInputContainer data-cy={`verification-code-input-container`}>
            {inputRefs.map((ref, index) =>
                <CustomTextField
                    data-cy={`verification-code-${index}`}
                    required
                    key={index}
                    inputRef={ref}
                    inputProps={{ min: 0, style: { textAlign: 'center' }, maxLength: 1 }}
                    error={errors[index] || errorFromOutside}
                    onChange={handleInputChange(index)} 
                    onBlur={handleBlur(index)}/>
            )}

        </VerificationCodeInputContainer>
    );
};

export interface VerificationCodeInputProps extends React.ComponentProps<typeof VerificationCodeInput> {
    as?: React.ElementType;
}

VerificationCodeInput.displayName = "VerificationCodeInput";